import { colorPalette } from '@rakutenfrance/material-ui';
export const getCouponClipboardStyles = (format, fromValue) => ({
    boxWrapper: {
        width: format === 'line' ? 1 : 'fit-content',
    },
    wrapper: {
        p: '12px',
        width: '100%',
        height: format === 'line' ? '44px' : fromValue == undefined ? '62px' : '80px',
        borderRadius: '8px',
        border: `1px dashed ${colorPalette.gray300}`,
        background: `${colorPalette.white}`,
        '&:hover': {
            cursor: 'pointer',
            background: colorPalette.gray100,
        },
    },
    container: {
        alignItems: format === 'line' ? 'center' : 'flex-start',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    tooltip: {
        '& > div': {
            display: 'flex',
            maxWidth: '300px',
            p: '8px',
            backgroundColor: colorPalette.gray900,
        },
    },
    icons: {
        color: colorPalette.gray700,
        height: '20px',
        width: '20px',
        ml: '8px',
    },
});
